"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminPlansSchema = exports.adminPlanArrSchema = exports.adminPlanSchema = exports.adminFragmentSchema = exports.adminStepSchema = exports.priorityBucketSchema = exports.PriorityBucket = exports.PlanPruneReason = exports.spawnPurposeSchema = exports.SpawnPurpose = exports.PlanFragmentStatus = exports.OrchestratorStepStatus = void 0;
const zod_1 = require("zod");
const plan_status_1 = require("./plan-status");
var OrchestratorStepStatus;
(function (OrchestratorStepStatus) {
    OrchestratorStepStatus["Created"] = "CREATED";
    OrchestratorStepStatus["Finalizing"] = "FINALIZING";
    OrchestratorStepStatus["Completed"] = "COMPLETED";
    OrchestratorStepStatus["Cancelled"] = "CANCELLED";
})(OrchestratorStepStatus || (exports.OrchestratorStepStatus = OrchestratorStepStatus = {}));
var PlanFragmentStatus;
(function (PlanFragmentStatus) {
    PlanFragmentStatus["Pending"] = "pending";
    PlanFragmentStatus["Complete"] = "complete";
    PlanFragmentStatus["Failed"] = "failed";
    PlanFragmentStatus["Cancelled"] = "cancelled";
})(PlanFragmentStatus || (exports.PlanFragmentStatus = PlanFragmentStatus = {}));
var SpawnPurpose;
(function (SpawnPurpose) {
    SpawnPurpose["FirstReview"] = "first_review";
    SpawnPurpose["DataScience"] = "data_science";
    SpawnPurpose["ReReview"] = "re_review";
    SpawnPurpose["UxResearch"] = "ux_research";
    SpawnPurpose["PackageDataAdjudication"] = "package_data_adjudication";
})(SpawnPurpose || (exports.SpawnPurpose = SpawnPurpose = {}));
exports.spawnPurposeSchema = zod_1.z.nativeEnum(SpawnPurpose);
var PlanPruneReason;
(function (PlanPruneReason) {
    PlanPruneReason["PrunedStale"] = "pruned_stale";
    PlanPruneReason["PrunedPublished"] = "pruned_published";
})(PlanPruneReason || (exports.PlanPruneReason = PlanPruneReason = {}));
var PriorityBucket;
(function (PriorityBucket) {
    PriorityBucket["Critical"] = "critical";
    PriorityBucket["Highest"] = "highest";
    PriorityBucket["Higher"] = "higher";
    PriorityBucket["Normal"] = "normal";
    PriorityBucket["Lower"] = "lower";
})(PriorityBucket || (exports.PriorityBucket = PriorityBucket = {}));
exports.priorityBucketSchema = zod_1.z.nativeEnum(PriorityBucket);
exports.adminStepSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: zod_1.z.string(),
    displayName: zod_1.z.string().nullable(),
    status: zod_1.z.nativeEnum(OrchestratorStepStatus),
    isClaimable: zod_1.z.boolean(),
    createdAt: zod_1.z.number(),
    deadlineAt: zod_1.z.number(),
    priorityBucket: exports.priorityBucketSchema.nullable(),
});
exports.adminFragmentSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    status: zod_1.z.nativeEnum(PlanFragmentStatus),
    claim: zod_1.z
        .object({
        userId: zod_1.z.string(),
        expiresAt: zod_1.z.number(),
        stepId: zod_1.z.string().nullable(),
    })
        .nullable(),
    displayMetadata: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    steps: exports.adminStepSchema.array(),
    completedByUserId: zod_1.z.string().nullable(),
    completedByUserName: zod_1.z.string().nullable(),
});
exports.adminPlanSchema = zod_1.z.object({
    id: zod_1.z.string(),
    fragments: zod_1.z.record(zod_1.z.string(), exports.adminFragmentSchema),
    status: zod_1.z.nativeEnum(plan_status_1.PlanStatus),
    createdAt: zod_1.z.number(),
    deadlineAt: zod_1.z.number(),
    completedAt: zod_1.z.number().nullable(),
    generator: zod_1.z.string(),
    packageId: zod_1.z.string().nullable(),
    manufacturerPartNumber: zod_1.z.string().nullable(),
    executionMode: zod_1.z.string().nullable(),
    assignedToUserId: zod_1.z.string().nullable(),
    assignedToUserName: zod_1.z.string().nullable(),
    assignedToOrgId: zod_1.z.string().nullable(),
    assignedToOrgName: zod_1.z.string().nullable(),
    priority: zod_1.z.number().nullable(),
});
exports.adminPlanArrSchema = exports.adminPlanSchema.omit({ fragments: true }).extend({
    fragments: exports.adminFragmentSchema.array(),
});
exports.adminPlansSchema = zod_1.z.object({
    plans: zod_1.z.record(zod_1.z.string(), exports.adminPlanSchema),
});
//# sourceMappingURL=admin.js.map